<template>
	<div class="layout">
		<div class="navber">
			<div class="content flex_r flex_jb">
				<div class="logo flex_r flex_ac">
					<img src="@/assets/img/layout/MemoryCube.png">
					<!-- <div class="name">乐启智慧</div> -->
					<!-- <div class="name">MemoryCube</div> -->
				</div>
				<div class="flex_r flex_ac">
					<div class="tabs flex_r flex_jc">
						<div :class="['tab_item',{active:i.name==activeName}]" @click="ontab(i.name)" v-for="i,s in tabs" :key="s">{{$t(i.label)}}</div>
					</div>
					<!-- <div class="tab">
						<div class="title">{{$t('index.buyNow')}}</div>
						<div class="options flex_c flex_jc">
							<div @click="to(i.url)" class="shop flex_r flex_ac flex_jc" v-for="i, s in shops" :key="s">
								<img :src="i.ico" class="ico">
								<div class="name">{{ i.name }}</div>
							</div>
						</div>
					</div> -->
					<div class="tab">
						<div @click="changeLanguage" class="title">{{ lang | langf }}</div>
						<div class="options flex_c flex_jc">
							<div @click="changeLang(i.value)" class="shop flex_r flex_ac flex_jc" v-for="i, s in langs" :key="s">
								<div class="name">{{ i.label }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<router-view />
	</div>
</template>

<script>
import { EventBus } from '@/utils/eventBus';
export default {
	name: "layout",
	data() {
		return {
			lang: this.$i18n.locale,
			tabs: [
				{ label: 'index.home', name: "home" },
				{ label: 'index.productCenter', name: "product" },
				{ label: 'index.techSupport', name: "distribute" },
				// { label: 'index.aboutus', name: "aboutus" },
				// { label: "技术支持", name: "support" },
			],
			activeName: "home",
			shops: [
				{ name: "淘宝", ico: require("@/assets/img/layout/taobao.png"), url: "https://shop395576459.taobao.com/?spm=a230r.7195193.1997079397.2.40d92c702dInCl" },
				{ name: "抖音", ico: require("@/assets/img/layout/douyin.png"), url: "https://v.douyin.com/iA3GgoUM/" },
				{ name: "京东", ico: require("@/assets/img/layout/jingdong.png"), url: "https://mall.jd.com/index-16454217.html" }
			],
			langs: [
				{ label: '简体中文', value: 'zh-CN' },
				{ label: 'English', value: 'en' }
			]
		};
	},
	created() {
		this.activeName = this.$route.name;
	},
	mounted() {
		EventBus.$on('changeTab', this.updateLayoutData);
	},
	methods: {
		ontab(name) {
			if (name) {
				this.activeName = name;
				this.$router.push(name);
			}
		},
		to(url) {
			window.open(url, "_blank")
		},
		updateLayoutData(newValue) {
			this.activeName = newValue
		},
		// 切换语言
		changeLanguage() {
			this.lang = this.lang === 'zh-CN' ? 'en' : 'zh-CN';
			localStorage.setItem('lang', this.lang);
			this.$i18n.locale = this.lang;
			// location.replace(location.href)
		},
		changeLang(va){
			this.lang = va;
			localStorage.setItem('lang', this.lang);
			this.$i18n.locale = this.lang;
		}
	},
};
</script>

<style lang="scss" scoped>
.navber {
	width: 100%;
	height: 41px;
	background-color: #222;
	position: fixed;
	left: 0; top: 0;
	z-index: 99;

	.logo {
		height: 40px;

		img {
			// width: 20px;
			height: 26px;
			// margin-right: 16px;
		}

		// .name {
		// 	color: #fff;
		// 	font-weight: bold;
		// 	font-size: 14px;
		// }
	}

	.tabs{
		color: #fff;
		font-size: 12px;
    	cursor: pointer;
		
		.tab_item{
			padding: 0 20px;

			&.active{
				color: #409EFF;
			}
		}
	}

	.tab {
		color: #fff;
		font-size: 12px;
		padding: 0 20px;
		position: relative;

		&:hover {
			color: #409EFF;
			cursor: pointer;

			.options {
				height: 118px;
				transition: height 0.5s;
			}
		}

		.title {
			height: 40px;
			line-height: 40px;
		}

		.options {
			color: #333;
			position: absolute;
			right: 0;
			background: #fff;
			border-radius: 8px;
			width: 100%;
			text-align: center;
			height: 0;
			transition: height 0.5s;
			overflow: hidden;

			.shop {
				padding: 8px 0;
				font-size: 15px;

				&:hover {
					color: #000;
					background-color: rgba($color: #000, $alpha: 0.1);
				}
			}

			.ico {
				width: 20px;
				height: 20px;
				margin-right: 6px;
			}
		}
	}
}
</style>